<template>
  <div>
      <Header title="即时评教" type="0" route="/student/evaluateOnTime" ></Header>
      <div class="tittleDiv">
         <div class="list-head">
          <p>{{baseData.kcmc}}</p>
          <ul>
            <li>上课老师：{{baseData.jgxm}}</li>
          </ul>
         </div>
      </div>
      <NOdata v-if="evaluateList.length == 0" title="暂无评教记录~"></NOdata>
      <div class="eva-body" v-else>
        <p>评论时间：{{pjTIme}}</p>
        <keep-alive>
				<textarea
				  placeholder=""
				  v-model="evaText"
				  maxlength="2000"
          readonly
				></textarea>
			  </keep-alive>
        <div class="eva-body-ts">
          <van-pagination v-model="currentPage" :page-count="pangCont"  mode="simple"  prev-text="上一条" next-text="下一条"></van-pagination>
        </div>
       <!--- <div class="grey-contain">
          
        </div>-->
        <div class="grey-contain_div" ></div>
      </div>
      <div class="history-btn">
        <button @click="goBack()">返回</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        warning:'',
        baseData:JSON.parse(this.$route.query.dataObj),
        evaText:'',
        currentPage:1,
        pangCont:10,
        pjTIme:''
      }
    },
    watch:{
      currentPage(val){
        this.evaText = this.evaluateList[val-1].pjnr;
           this.pjTIme = this.evaluateList[val-1].pjsj;
      }
    },
    methods:{
      lookMyEvaluateRecod(){
        this.$router.push({
                path: '/student/findMyEvaluateRecod',
                query: {
                   dataObj: JSON.stringify(obj)
                }
            });
      },
      async initData(){
        const params = {
          jx0404id:this.baseData.jx0404id,
          jg0101id:this.baseData.jg0101id
        };
        const res = await Api.findMyEvaluateHistoryList(params);
        if(res.code=='1'){
           this.evaluateList = res.data;
           this.evaText = this.evaluateList[0].pjnr;
           this.pjTIme = this.evaluateList[0].pjsj;
           this.pangCont = this.evaluateList.length; 
        }
      },
      goBack(){
        this.$router.push({
                path: '/student/evaluateOnTime',
            });
      }
    },
    created(){
       this.initData();
    },
  }
</script>

<style lang="less" scoped>
.tittleDiv{
  padding: 3% 5% 0;
	background-color: #ffffff;
	height: 80px;
	.list-head {
	  height: 100%;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
    p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
	  }
    ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}
  }
}
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{
    padding: 3% 5% 0;
    position: fixed;
    top: 140px;
    bottom: 90px;
    width: 95%;
    p{
      font-family: PingFangSC-Medium;
      color: #151618;
      font-size: 15px;
      font-weight: 600;
      line-height: 25px;
    }
    span {
      color: @attendance-color-2;
      position: relative;
      bottom: 0px;
      right: 10px;
      color: red;
      font-size: 12px;
   }
   .eva-body-ts{
     padding: 3% 5% 0;
     padding-top:0;
     padding-left: 0;
     text-align: center;

   }
  }
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 10px;box-sizing: border-box;height: 85px;}
  .history-btn button{width:100%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;}

 .eva-body textarea {
   width: 95%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 85%;
   padding-bottom: 15px;
   position: relative;
 }

</style>

<style lang="less" scoped>
 

 /deep/ .van-pagination__item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    box-sizing: border-box;
    min-width: 36px;
    height: 40px;
    color: #7469F8;
    background-color: #fff;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}

/deep/ .van-pagination__item--active{
  color: #fff;
  background-color: #7469F8;
 }
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/evaluateOnTimeHistory.vue